import styles from "./TrustedFeatures.module.scss";

export default function TrustedFeatures() {
  return (
    <section className={styles.trustedFeatures}>
      <div className={styles.grid}>
        <div className={styles.item}>
          <h6>Garantía del 100% al comprador.</h6>
          <p>Experiencia segura y sin preocupaciones.</p>
        </div>
        <div className={styles.item}>
          <h6 className="ms-3">Tus datos, siempre protegidos.</h6>
          <p className="ms-3">Tenemos los más altos estándares de seguridad.</p>
        </div>
        <div className={styles.item}>
          <h6 className="ms-3">Atención al cliente integral</h6>
          <p className="ms-3">
            Desde el primer clic hasta que finalices tu compra.
          </p>
        </div>
      </div>
    </section>
  );
}
